module.exports = __webpack_public_path__ + "img/L_301_362.9b38a18d.png";